<div class="decline-consent-status-container">
  <p>Click Decline to update the family consent status to reflect that this family has declined to participate in the "Every Child and Family is Known" program</p>
  <p>To participate and gain access to the Family Portal, the primary guardian must sign a consent form.</p>
</div>
